import axios from "axios";
import { getToken, removeToken } from "../utils/role";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import router from "../router/index";
// const baseUrl = "http://api.imonment.top/v1/user";

const baseUrl = "http://127.0.0.1:8012/api/v1/";

const service = axios.create({
  baseURL: baseUrl,
  timeout: 5000,
});

// 请求前拦截
service.interceptors.request.use(
  (config) => {
    NProgress.start();
    config.headers["Authorization"] = getToken();
    return config;
  },
  (error) => {
    NProgress.done();
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// 请求后拦截
service.interceptors.response.use((response) => {
  NProgress.done();
  if (response.status !== 200) {
    removeToken();
    return router.push({ name: "Login" });
  } else {
    if (response.data.code > 500) {
      removeToken();
      return router.push({ name: "Login" });
    }
    return response.data;
  }
});

export default service;
